import type { ISelectedModel } from '@/modules/backoffice/types/terminal';

export const POS_MODELS: ISelectedModel[] = [
  { id: 61, name: 'P2' },
  { id: 66, name: 'X990' },
  { id: 38, name: 'A910' },
  { id: 40, name: 'L300' },
];
